import React, { useEffect } from 'react';
import postscribe from 'postscribe';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { buildCurrentMemberSelector } from 'store/selectors/members.selector';
import { loadZinreloData } from 'store/dispatchers/members.dispatchers';
import { buildZinrelosSelector } from 'store/selectors/zinrelos.selector';
import _ from 'lodash';
import ReturnTopButton from 'components/UI/ReturnTopButton';
import FeedBackButton from 'components/UI/FeedBackButton';

function Footer({ authMember, getZinreloData, getStoredZinrelo })
{
    const initZinrelo = (zinreloData) =>
    {
        if (zinreloData)
        {
            window._zrl = window._zrl || [];
            window._zrl.push(['init', zinreloData]);
        }
    };
    function loadZinreloWidget()
    {
        const storedZinrelo = getStoredZinrelo(authMember.defaultEmail);
        if (!_.isEmpty(storedZinrelo))
        {
            initZinrelo(storedZinrelo);
            return;
        }

        getZinreloData(authMember.defaultEmail).then((zinreloData) =>
        {
            initZinrelo(zinreloData);
        });
    }

    useEffect(() =>
    {
        delete window._zrl;
        delete window._ssq;
        delete window.ss_mi;
        delete window.zrl_mi;
        if (authMember?.defaultEmail)
        {
            postscribe('#react-app', '<script src="//cdn.zinrelo.com/js/all.js" type="text/javascript"></script>', {
                done: loadZinreloWidget,
            });
        }
    }, [authMember]);

    return (
        <footer>
            <div className="tw-w-full tw-p-10 lg:tw-pl-[248px]">
                <ReturnTopButton />
                <FeedBackButton />
            </div>

        </footer>
    );
}

Footer.propTypes = {
    authMember: PropTypes.shape({
        defaultEmail: PropTypes.string,
    }),
    getZinreloData: PropTypes.func,
    getStoredZinrelo: PropTypes.func,
};

const mapStateToProps = () =>
{
    const authMemberSelector = buildCurrentMemberSelector();
    const zinreloSelector = buildZinrelosSelector();

    return (state) => ({
        authMember: authMemberSelector(state),
        getStoredZinrelo: (email) => zinreloSelector(state, email),
    });
};

const mapDispatchToProps = (dispatch) => ({
    getZinreloData(email)
    {
        return dispatch(loadZinreloData(email));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
